import { parseFloatData } from '../commonUtils';

const getCurrentAmountAndCreditBalance = ({
  useCreditBalance, creditBalance = 0, currentTotalAmount = 0, thirdPartyAmount = 0,
}) => {
  const maxCreditBalance = parseFloatData(currentTotalAmount - thirdPartyAmount);
  if (useCreditBalance && maxCreditBalance > 0) {
    if (creditBalance >= maxCreditBalance) {
      return {
        currentCreditBalance: maxCreditBalance,
        currentAmountDue: thirdPartyAmount,
      };
    }
    return {
      currentCreditBalance: creditBalance,
      currentAmountDue: currentTotalAmount - creditBalance,
    };
  }
  return {
    currentCreditBalance: 0,
    currentAmountDue: currentTotalAmount,
  };
};

export default getCurrentAmountAndCreditBalance;
